module.exports = __webpack_public_path__ + "img/hfgc.8c98fbb1.jpg";